import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dropdownContainer: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "0px 5px",
  },
  dropdownContainer2: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "5px",
    padding: "0px 5px",
  },

  select: {
    padding: "0.2px 6px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    width: "100%",
    height: "40px",
    color: "white",
    cursor: "pointer",
  },
  select2: {
    padding: "0.2px 6px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "10px",
    width: "100%",
    height: "30px",
    color: "white",
    cursor: "pointer",
    fontSize: "12px",
    [theme.breakpoints.up("xl")]: {
      fontSize: "14px",
    },
  },
}));

export default useStyles;
